const Input = {
  baseStyle: {
    field: {
      transition: "background-color .1s ease-in-out",
      bg: "gray.200",
      color: "gray.900",
      _focus: {
        boxShadow: "inset 0px 0px 1px 3px #00BFF3"
      },
      _invalid: {
        boxShadow: "inset 0px 0px 1px 3px #e53e3e"
      }
    }
  },
  variants: {
    solid: {
      field: {
        bg: "gray.700",
        boxShadow: "0px 4px 7px -1px rgba(0, 0, 0, 0.25)",
        borderRadius: "10px",
        color: "white",
        _placeholder: {
          color: "white",
          opacity: 0.6
        }
      }
    },
    outline: {
      field: {
        bg: "transparent",
        borderRadius: "10px",
        color: "white",
        _placeholder: {
          color: "white",
          opacity: 0.6
        }
      }
    },
    dark: {
      field: {
        bg: "gray.800",
        boxShadow: "0px 4px 7px -1px rgba(0, 0, 0, 0.25)",
        color: "white",
        _placeholder: {
          color: "white"
        }
      }
    }
  },
  sizes: {
    md: {
      field: {
        fontSize: "md",
        rounded: "xl",
        py: 2,
        px: 4,
        height: "unset"
      }
    },
    xl: {
      field: {
        fontSize: "xl",
        letterSpacing: "0.9px",
        rounded: "3xl",
        py: 4,
        px: 6,
        height: "unset",
        overflow: "hidden"
      }
    }
  },
  defaultProps: {
    size: "lg",
    variant: "solid"
  }
};

export default Input;
